export default {
  notifications: {
    page: {
      title: 'Notifications',
      settings: 'Settings',
      settingsTitle: 'Notification Settings',
    },
    bell: {
      ariaUnread: '{count} unread notifications',
      ariaNone: 'No unread notifications',
      title: 'Notifications',
      loading: 'Loading…',
      empty: 'No notifications',
      markAllRead: 'Mark all read',
      viewAll: 'View all',
    },
    list: {
      emptyTitle: 'No Notifications',
      emptyDescription: 'You have no notifications yet',
    },
    item: {
      markAsRead: 'Mark as read',
      justNow: 'just now',
      minutesAgo: '{count}m ago',
      hoursAgo: '{count}h ago',
      daysAgo: '{count}d ago',
    },
    preferences: {
      pushTitle: 'Push on This Device',
      pushNotSupported: 'Not supported in this browser',
      pushEnabled: 'Notifications enabled on this device',
      pushBlocked: 'Blocked by browser. Allow in site settings',
      pushAllow: 'Allow notifications on this device',
      chooseHow: 'Choose how you want to receive notifications',
      messengers: 'Messengers',
      telegramTitle: 'Telegram',
      telegramDescription: 'Receive notifications via Telegram bot',
      whatsappTitle: 'WhatsApp',
      whatsappComingSoon: 'Coming soon',
      connect: 'Connect',
      disconnect: 'Disconnect',
      cancel: 'Cancel',
      save: 'Save Changes',
      saving: 'Saving…',
      channels: {
        web: {
          name: 'Web Notifications',
          description: 'Real-time notifications in your browser',
        },
        push: {
          name: 'Mobile Push Notifications',
          description: 'Notifications on your mobile device even when the app is closed',
        },
        email: {
          name: 'Email Notifications',
          description: 'Receive notifications in your email inbox',
        },
        sms: {
          name: 'SMS Notifications',
          description: 'Get text messages for important notifications',
        },
        telegram: {
          name: 'Telegram Messages',
          description: 'Receive notifications via Telegram bot',
        },
        whatsapp: {
          name: 'WhatsApp Messages',
          description: 'Get notifications as WhatsApp messages',
        },
      },
    },
  },
};
